import { render, staticRenderFns } from "./academic_referee_system.vue?vue&type=template&id=273e7dc6&scoped=true&"
import script from "./academic_referee_system.vue?vue&type=script&lang=js&"
export * from "./academic_referee_system.vue?vue&type=script&lang=js&"
import style0 from "./academic_referee_system.vue?vue&type=style&index=0&id=273e7dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e7dc6",
  null
  
)

export default component.exports